import type { FieldDescriptor } from '../../types/common';
import type { FlexibleDoublePicksFieldType } from './types';
import { FlexibleDoublePicksField } from './FlexibleDoublePicksField';
import { createValidationSchema } from './validation';

const Descriptor: FieldDescriptor<FlexibleDoublePicksFieldType> = {
  FieldComponent: FlexibleDoublePicksField,
  name: 'FlexibleDoublePicksField',
  createValidationSchema,
};

export default Descriptor;

export type {
  FlexibleDoublePicksFieldType,
  FlexibleDoublePicksValue,
  SlateConfiguration,
} from './types';
